export default __webpack_public_path__ + "static/media/focos-led.771ebc96.png";